import axios from 'lib/axios'

export const getOvertimeRate = () => {
  return axios.get('admin/company-overtime')
}

export const postOvertimeRate = (data) => {
  return axios.post('admin/company-overtime', data)
}

export const deleteOvertimeRate = ({ id }) => {
  return axios.delete(`admin/company-overtime/${id}`)
}
